import { Route, Routes } from 'react-router-dom'
import { UserAuthentication } from './components/functionals'

// home
import Home from './pages/home/Home'

// building
import { BuildingImport } from './pages/building/import/BuildingImport'
import { BuildingSearch } from './pages/building/search/BuildingSearch'

// simulation
import { DigestiveSimulation } from './pages/simulation/digestive-simulation/DigestiveSimulation'
import { LaborStackManagementTable } from './pages/simulation/labor-stack-management-table/LaborStackManagementTable'
import { ManualSimulationAllotment } from './pages/simulation/manual-simulation-allotment/ManualSimulationAllotment'
import { SimulationExecution } from './pages/simulation/simulation-execution/SimulationExecution'
import { SimulationExport } from './pages/simulation/simulation-export/SimulationExport'
import { SimulationBuildingSearch } from './pages/simulation/simulation-building-search/SimulationBuildingSearch'
import { StatusList } from './pages/simulation/status-list/StatusList'

// supplier
import { BuildingDecidedBySupplier } from './pages/supplier/building-decided-by-supplier/BuildingDecidedBySupplier'
import { ConfirmReply } from './pages/supplier/confirm-reply/ConfirmReply'
import { HearingSheet } from './pages/supplier/hearing-sheet/HearingSheet'
import { OtherCompaniesBuilding } from './pages/supplier/other-companies-building/OtherCompaniesBuilding'
import { QuotationRequestBuilding } from './pages/supplier/quotation-request-building/QuotationRequestBuilding'
import { ReplyAggregationGraph } from './pages/supplier/reply-aggregation-graph/ReplyAggregationGraph'
import { StatusCheck } from './pages/supplier/status-check/StatusCheck'
import { SufficiencyOfQuantity } from './pages/supplier/sufficiency-of-quantity/SufficiencyOfQuantity'

// maintenance
import AuthSearch from './pages/maintenance/auth/AuthSearch'
import CodeNameSearch from './pages/maintenance/code-name/CodeNameSearch'
import ConstPeriodSettingSearch from './pages/maintenance/const-period/ConstPeriodSettingSearch'
import StructureSearch from './pages/maintenance/structure/StructureSearch'
import { SupplierSearch } from './pages/maintenance/supplier/SupplierSearch'

// systems
import AuthorityError from './pages/systems/AuthorityError'
import RequestError from './pages/systems/RequestError'
import LoginRedirect from './pages/systems/LoginRedirect'
import Logout from './pages/systems/Logout'
import RoutingError from './pages/systems/RoutingError'

export default function Routing() {
  return (
    <Routes>
      <Route path="/" element={<UserAuthentication />}>
        <Route index element={<Home />} />
      </Route>

      <Route path="building" element={<UserAuthentication />}>
        <Route path="import" element={<BuildingImport />} />
        <Route path="search" element={<BuildingSearch />} />
      </Route>

      <Route path="simulation" element={<UserAuthentication />}>
        <Route path="building-search" element={<SimulationBuildingSearch />} />
        <Route path="digestive-simulation" element={<DigestiveSimulation />} />
        <Route path="execution" element={<SimulationExecution />} />
        <Route path="export" element={<SimulationExport />} />
        <Route path="labor-stack-management-table" element={<LaborStackManagementTable />} />
        <Route path="manual-simulation-allotment" element={<ManualSimulationAllotment />} />
        <Route path="status-list" element={<StatusList />} />
      </Route>

      <Route path="supplier" element={<UserAuthentication />}>
        <Route path="building-decided" element={<BuildingDecidedBySupplier />} />
        <Route path="confirm-reply" element={<ConfirmReply />} />
        <Route path="hearing-sheet" element={<HearingSheet />} />
        <Route path="other-companies-building" element={<OtherCompaniesBuilding />} />
        <Route path="quotation-request-building" element={<QuotationRequestBuilding />} />
        <Route path="reply-aggregation-graph" element={<ReplyAggregationGraph />} />
        <Route path="status-check" element={<StatusCheck />} />
        <Route path="sufficiency-of-quantity" element={<SufficiencyOfQuantity />} />
      </Route>

      <Route path="maintenance" element={<UserAuthentication />}>
        <Route path="code-name" element={<CodeNameSearch />} />
        <Route path="const-period" element={<ConstPeriodSettingSearch />} />
        <Route path="structure" element={<StructureSearch />} />
        <Route path="auth" element={<AuthSearch />} />
        <Route path="supplier" element={<SupplierSearch />} />
      </Route>

      <Route path="authority-error" element={<AuthorityError />} />
      <Route path="request-error" element={<RequestError />} />
      <Route path="callback" element={<LoginRedirect />} />
      <Route path="logout" element={<Logout />} />
      <Route path="/*" element={<RoutingError />} />
    </Routes>
  )
}
